import { useMutation } from '@tanstack/react-query'
import { api } from '@api'
import { QueryClient } from '@tanstack/react-query'
import { showSuccessToast } from '@utils'
import { useLanguage } from '@context'

const deleteGhostProfile = async (ghostProfileId: string): Promise<void> => {
  await api.delete(`/ghost-profiles/${ghostProfileId}`)
}

export const useDeleteGhostProfile = () => {
  const queryClient = new QueryClient()
  const { t } = useLanguage()
  return useMutation<void, Error, string>({
    mutationFn: deleteGhostProfile,
    onSuccess: () => {
      showSuccessToast(t('toast.success'), t('ghostProfile.deleteSuccess'))
      queryClient.invalidateQueries({ queryKey: ['contacts'] })
    }
  })
}
